import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Department & Organization Module Service Stores
 * Updated to match backend api-types
 *
 * Note: No department-specific api-types exist yet. These services
 * are kept for backward compatibility but may need to be moved or removed
 * once the backend types are finalized.
 */
export const departmentStores: ServiceStoreConfig[] = [
  // Keeping existing services for now as they don't have api-types yet
  // These may need to be moved to a different module or removed in the future
];
